module.exports = __webpack_public_path__ + "img/实体卡.399d5809.png";